'use client';
import { shallowEqual } from '@mnd-frontend/utils';
import { useRef } from 'react';

export default function useMemoObject<T>(object: T) {
  const ref = useRef<T>(object);
  if (!shallowEqual(object, ref.current)) ref.current = object;
  return ref.current;
}
